module.exports = __webpack_public_path__ + "static/media/xoleg_normal_left.70e9958d.png";